import dayjs from "dayjs";
import { Combo, InputFactoryProp } from "../../../../../../shared/interfaces";
import { REJECTIONS_TYPES_VALUES, RejectionsTypesValues } from "../../shared/enums/rejections-types-enum";

const yearFilter: InputFactoryProp = {
    element: 'onlydate',
    placeHolder: 'Año',
    allowClear: true,
    picker: 'year',
    mode: 'year',
    format: 'YYYY',
    name: 'year',
    minDate: dayjs('2016-01-01')
};
 
const monthFilter: InputFactoryProp = {
    element: 'onlydate',
    placeHolder: 'Mes',
    allowClear: true,
    name: 'month',
    mode: 'month',
    picker: 'month',
    format: 'MMMM',
    minDate: dayjs().startOf('year'),
    maxDate: dayjs().endOf('year')
};

const creditCardFilter = (creditCardsCompaniesCombo: Combo[]): InputFactoryProp => ({
    placeHolder: 'Tipo tarjeta',
    items: creditCardsCompaniesCombo,
    element: 'select',
    name: 'entity',
    allowClear: true
});

export const getInputsFilter = (creditCardsCompaniesCombo: Combo[], type: RejectionsTypesValues): InputFactoryProp[] => {
    const baseFilters = [yearFilter, monthFilter];
    return type === REJECTIONS_TYPES_VALUES.CREDITO
        ? [...baseFilters, creditCardFilter(creditCardsCompaniesCombo)]
        : baseFilters;
};